
<j-gateway-group
      :source="node"
      v-on="$listeners" 
      :configs="configs">
      <j-icon :configs="imageConfig"></j-icon>
  </j-gateway-group>
